import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    button: {
      width: '100%',
      marginTop: 28,
      borderRadius: 48,
    },
  },
  { name: 'FilterModal' },
);
